import { ThunkAction } from 'redux-thunk'
import store, { RootState } from '..'
import { ActionEnum, AlertMessageEnum } from '../../common'
import { translate } from '../../languages'
import {
  CommonAction,
  SET_ACTION,
  SET_ACTION_PROCESSING,
  SET_ALERT_MESSAGE,
  SET_SHOW_MANAGE_MODAL,
  SET_SHOW_RESET_PASSWORD_MODAL,
  SET_SHOW_SEARCH_DRAWER,
} from '../types'

export const setAction = (
  action: ActionEnum
): ThunkAction<void, RootState, null, CommonAction> => {
  return (dispatch) => {
    dispatch({
      type: SET_ACTION,
      payload: action,
    })
  }
}

export const setActionProcessing = (
  processing: boolean
): ThunkAction<void, RootState, null, CommonAction> => {
  return (dispatch) => {
    dispatch({
      type: SET_ACTION_PROCESSING,
      payload: processing,
    })
  }
}

export const setShowManageModal = (
  visible: boolean
): ThunkAction<void, RootState, null, CommonAction> => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_MANAGE_MODAL,
      payload: visible,
    })
  }
}

export const setShowSearchDrawer = (
  visible: boolean
): ThunkAction<void, RootState, null, CommonAction> => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_SEARCH_DRAWER,
      payload: visible,
    })
  }
}

export const setShowResetPasswordModal = (
  visible: boolean
): ThunkAction<void, RootState, null, CommonAction> => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_RESET_PASSWORD_MODAL,
      payload: visible,
    })
  }
}

export const setAlert = (alert?: {
  key: string
  type: AlertMessageEnum
}): CommonAction => {
  const { language } = store.getState().language
  return {
    type: SET_ALERT_MESSAGE,
    payload: alert
      ? {
          message: translate(alert.key, language),
          type: alert.type,
        }
      : undefined,
  }
}
